module.exports = __webpack_public_path__ + "static/media/paperclipWhite.48ec6f3a.svg";